/**
 * Maps Foursixty slider controls to theme .slider__button styles (square 40px, masks, hover).
 */
(function () {
  if (window.__igFoursixtyThemeNav) return;
  window.__igFoursixtyThemeNav = true;

  var scheduled = false;

  function patchEmbed(embed) {
    if (!embed || !embed.classList.contains('ig-gallery__embed')) return;
    var prev = embed.querySelector('.fs-slider-prev-button');
    var next = embed.querySelector('.fs-slider-next-button');
    if (prev && !prev.dataset.themeSliderPatched) {
      prev.classList.add('slider__button', 'slider__button--prev');
      prev.dataset.themeSliderPatched = 'true';
    }
    if (next && !next.dataset.themeSliderPatched) {
      next.classList.add('slider__button', 'slider__button--next');
      next.dataset.themeSliderPatched = 'true';
    }
  }

  function scan() {
    document.querySelectorAll('.ig-gallery-small .ig-gallery__embed').forEach(patchEmbed);
  }

  function scheduleScan() {
    if (scheduled) return;
    scheduled = true;
    requestAnimationFrame(function () {
      scheduled = false;
      scan();
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', scan);
  } else {
    scan();
  }

  var mo = new MutationObserver(scheduleScan);
  mo.observe(document.documentElement, { childList: true, subtree: true });
})();
